import { useState } from "react";

interface RejectActionProps {
  onReject: (reason: string) => Promise<void>;
}

export function RejectAction({ onReject }: RejectActionProps) {
  const [reason, setReason] = useState("");

  const isValid = reason.length >= 10;

  return (
    <div className="reject-action">
      <textarea
        placeholder="Reason for rejection (min 10 characters)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
      <button
        disabled={!isValid}
        onClick={() => void onReject(reason)}
      >
        Reject batch
      </button>
    </div>
  );
}
